import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TrackClickModule } from '@libs/src/track-click/track-click.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { ProfileActionModule } from '@main-client/src/app/profile/profile-action/profile-action.module';
import { ProfileIcebreakersEditDialogModule } from '@main-client/src/app/profile/profile-icebreakers-edit-dialog/profile-icebreakers-edit-dialog.module';
import { ProfileMessageDialogModule } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.module';

import { ProfileIcebreakersComponent } from './profile-icebreakers.component';

@NgModule({
  declarations: [ProfileIcebreakersComponent],
  exports: [ProfileIcebreakersComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    ProfileActionModule,
    ProfileIcebreakersEditDialogModule,
    ProfileMessageDialogModule,
    TrackClickModule,
    TranslationLookupModule,
  ],
})
export class ProfileIcebreakersModule {}
